import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import useGet from "./useGet";
import useUpdate from "./useUpdate";
import { EditActionContext } from "./EditActionContext";
import BeelditGenericForm from "@beeldit/core/components/BeelditGenericForm";
import { FloppyDisk } from "@phosphor-icons/react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";

function useEditWithModalAction(modelConfig: any): any {
  const get = useGet(modelConfig);
  const getFunction = (id: number) => get(id);

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = () => {
    setShowModal(false);
  };

  const update = useUpdate(modelConfig);
  const updateFunction = () => update(onSuccessUpdate);

  /** Creation and edition modal element definition */
  const contextInstance = useContext(EditActionContext);
  const { showModal, setShowModal } = contextInstance;
  const { element, setElement, loading } = contextInstance;

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: "Edit " + modelConfig.modelName,
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
    fullscreen: true,
    size: "xxl",
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      updateFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    contextInstance: contextInstance,
  };

  const actionTemplate = (
    <>
      <CrudModuleFactoryModal modalConfig={modalConfig}>
        <div className="mt-5">
          <div className="d-flex justify-content-start align-items-center mb-3">
            {/* Botón para añadir mascotas a la derecha */}

            <button
              type="button"
              className="ms-3 mb btn btn-outline-primary"
              disabled={loading}
              onClick={() => {
                formRef.current?.formElement.current.requestSubmit();
              }}
            >
              <FloppyDisk size={25}></FloppyDisk> Guardar datos
            </button>
          </div>

          <BeelditGenericForm
            key={element ? element.id : 0}
            formConfig={formConfig}
            modelConfig={modelConfig}
          />
        </div>
      </CrudModuleFactoryModal>
    </>
  );

  /** END EDIT FORM ACTION */

  return {
    getFunction,
    actionTemplate,
  };
}

export default useEditWithModalAction;
